import { TabsV2 } from 'common/tabs/tab.v2.js';
import { ScreenSizeContext } from 'page-context/column-layout/column-layout-context.js';
import { useContext, useMemo, useState } from 'react';
import { isLargeView } from 'utilities/media-queries.js';
import { GlossarySection } from './glossary-section.js';

export interface IGlossary {
  sections: IGlossarySection[];
}

export interface IGlossarySection {
  title: string;
  items: Array<IGlossaryItem>;
  key: string;
}

export interface IGlossaryItem {
  heading: IGlossaryLink;
  children?: IGlossaryLink[];
}

interface IGlossaryLink {
  label: string;
  url: string;
}

export interface ISectionProps {
  title: string;
  items: Array<IGlossaryItem>;
  classes?: string;
  trackingOrigin?: string;
}

const SmallGlossaryComponent = ({ sections, trackingOrigin }: { sections: Array<IGlossarySection>, trackingOrigin?: string }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const renderedTab = useMemo(() => {
    const activeSection = sections[activeTabIndex];
    return <GlossarySection title={activeSection.title} items={activeSection.items} key={activeTabIndex}  trackingOrigin={trackingOrigin}/>;
  }, [activeTabIndex, sections, trackingOrigin]);

  return (
    <TabsV2
      headers={sections.map(({ title }, i) => ({ content: title, key: i }))}
      tabContainerClasses="Tab--slim"
      activeTabCallback={setActiveTabIndex}
    >
      {renderedTab}
    </TabsV2>
  );
};

// @TODO Revisit this and check the number of search columns that can be sent
const LargeGlossaryComponent = ({ sections, trackingOrigin }: { sections: Array<IGlossarySection>, trackingOrigin?: string }) => {
  return (
    <div className="Grid Grid--withGutter Section-Glossary--large u-flex">
      {sections.map(({ key, title, items }, i) => (
        <div key={key || i} className="u-flex-1 col-gutter">
          <GlossarySection title={title} items={items} classes="u-mT-responsive" trackingOrigin={trackingOrigin} />
        </div>
      ))}
    </div>
  );
};

export const Glossary = ({ sections, trackingOrigin }: IGlossary & { trackingOrigin?: string }) => {
  const isLarge = isLargeView(useContext(ScreenSizeContext));
  if (isLarge) {
    return <LargeGlossaryComponent sections={sections} trackingOrigin={trackingOrigin} />;
  }
  return <SmallGlossaryComponent sections={sections} trackingOrigin={trackingOrigin} />;
};
